import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Icon,
  Input,
  InputGroup,
  InputLeftElement,
} from "@chakra-ui/react";
import { t } from "i18next";
import { debounce } from "lodash";
import { useEffect, useMemo, useState } from "react";
import { FaSearch } from "react-icons/fa";
import { AdminOrgDto, useAdminListOrganizationsQuery } from "../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../common/auth/useLoggedInWithOrgContextState";
import { Paging } from "../../../common/Paging";
import { DebugPrint } from "../DebugPrint";
import { AdminEditOrganizationModal } from "./AdminEditOrganizationModal";
import { AdminImpersonateUserModal } from "./AdminImpersonateUserModal";

export const OrgsList = () => {
  const authState = useLoggedInWithOrgContextState();
  const [skip, setSkip] = useState(0);
  const [limit] = useState(10);
  const [name, setName] = useState("");
  const [debouncedName, setDebouncedName] = useState("");

  const debounced = useMemo(
    () =>
      debounce((v: string) => {
        setDebouncedName(v.trim());
      }, 300),
    []
  );
  useEffect(() => {
    debounced(name);
    return () => debounced.cancel();
  }, [name, debounced]);

  const { data, isLoading, isFetching } = useAdminListOrganizationsQuery({
    organizationId: authState.selectedOrg.id,
    skip,
    limit,
    name: debouncedName || undefined,
  });
  const [updateOrganization, setUpdateOrganization] = useState<AdminOrgDto>();
  const [impersonateOrganization, setImpersonateOrganization] = useState<AdminOrgDto>();

  if (!data) return <div>{t("Loading")}...</div>;

  return (
    <>
      {updateOrganization && (
        <AdminEditOrganizationModal
          organization={updateOrganization}
          onClose={() => setUpdateOrganization(undefined)}
        />
      )}
      {impersonateOrganization && (
        <AdminImpersonateUserModal
          organization={impersonateOrganization}
          onClose={() => setImpersonateOrganization(undefined)}
        />
      )}
      <InputGroup size="sm" mb="4">
        <InputLeftElement>
          <Icon as={FaSearch} color="smMuted" />
        </InputLeftElement>
        <Input
          placeholder={String(t("Search by name"))}
          value={name}
          onChange={(e) => {
            setSkip(0);
            setName(e.target.value);
          }}
        />
      </InputGroup>
      <Accordion allowMultiple reduceMotion>
        {data.orgs.map((org) => {
          return (
            <AccordionItem key={org.id}>
              <h2>
                <AccordionButton>
                  <Box as="span" flex="1" textAlign="left">
                    {org.name}
                  </Box>
                  <AccordionIcon />
                </AccordionButton>
              </h2>
              <AccordionPanel pb={4}>
                <Button mb="10px" variant={"solid"} colorScheme="blue" onClick={() => setUpdateOrganization(org)}>
                  {t("Edit")}
                </Button>
                <Button
                  mb="10px"
                  variant={"solid"}
                  colorScheme="purple"
                  onClick={() => setImpersonateOrganization(org)}
                >
                  {t("Impersonate")}
                </Button>
                <DebugPrint data={org} />
              </AccordionPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
      <Paging limit={limit} skip={skip} setSkip={setSkip} isLoading={isLoading || isFetching} count={data.count} />
    </>
  );
};
